if (!customElements.get('senshen-showcase')) {
  customElements.define('senshen-showcase', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('ul');
      this.onReturn = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onReturn);
      this.refresh();
    }

    disconnectedCallback() {
      this.controller?.abort();
      document.removeEventListener('visibilitychange', this.onReturn);
    }

    async groupCards(group, signal) {
      const path = this.dataset[group];
      if (!path) return [];
      const source = new URL(path, location.origin);
      if (source.origin !== location.origin) throw new Error('Unexpected showcase collection');
      const section = `senshen-showcase-${group}`;
      let url = new URL(source);
      const cards = [];
      const visited = new Set();
      while (url && cards.length < 2) {
        url.searchParams.set('sort_by', 'price-descending');
        url.searchParams.set('filter.v.availability', '1');
        url.searchParams.set('section_id', section);
        if (visited.has(url.href)) throw new Error('Repeated showcase page');
        visited.add(url.href);
        const response = await fetch(url, { signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Showcase collection unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = html.querySelector('[data-showcase-feed]');
        if (!feed) throw new Error('Showcase response missing');
        cards.push(...feed.querySelectorAll(`[data-showcase-group="${group}"]`));
        if (cards.length >= 2 || !feed.dataset.next) break;
        const next = new URL(feed.dataset.next, source);
        if (next.origin !== source.origin || next.pathname !== source.pathname) throw new Error('Unexpected showcase page');
        url = next;
      }
      return cards.slice(0, 2);
    }

    async refresh() {
      this.controller?.abort();
      const controller = this.controller = new AbortController();
      const groups = ['singles', 'graded', 'etb'];
      const results = await Promise.allSettled(groups.map(group => this.groupCards(group, controller.signal)));
      if (controller.signal.aborted || !this.isConnected || this.contains(document.activeElement)) return;
      const fragment = document.createDocumentFragment();
      groups.forEach((group, index) => {
        const result = results[index];
        const cards = result.status === 'fulfilled'
          ? result.value
          : [...this.grid.querySelectorAll(`[data-showcase-group="${group}"]`)];
        cards.forEach(card => fragment.append(card));
      });
      this.grid.replaceChildren(fragment);
      this.dataset.loaded = 'true';
    }
  });
}
